import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


export enum AccountModeType {
    Email = 'email',
    Phone = 'phone',
    Google = 'google',
}

/**
 * User data interaction mode switch
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-account-mode-switcher',
    templateUrl: './account-mode-switcher.component.html',
    styleUrls: ['./account-mode-switcher.component.scss'],
    imports: [TranslateModule, UpperCasePipe],
    standalone: true,
})
export class AccountModeSwitcherComponent {
    /**
     * Email mode mail or phone
     */
    @Input() public mode: AccountModeType = AccountModeType.Phone;
    /**
     * Change mode
     */
    @Output() public setModeType: EventEmitter<AccountModeType> = new EventEmitter<AccountModeType>();

    public readonly accountModeType: typeof AccountModeType = AccountModeType;

    public clickItem(mode: AccountModeType): void {
        this.setModeType.emit(mode);

        switch (mode) {
            case AccountModeType.Email:
                document.querySelector('#email-field-tab')[0]?.focus();

                break;

            case AccountModeType.Phone:
                document.querySelector('#phone-field-tab')[0]?.focus();

                break;

        }
    }
}
